import { useGetUserGroupGrades } from '@repo/api/grade/useGetUserGroupGrades';
import { format } from 'date-fns';
import { ArrowUpRight } from 'lucide-react';
import { useNavigate } from 'react-router';

import GradeDetailsPopup from '@/components/features/grades/GradeDetailsPopup';
import GradeValuePill from '@/components/features/grades/GradeValuePill';
import { Badge } from '@/components/ui/badge';
import { Label } from '@/components/ui/label';
import { Skeleton } from '@/components/ui/skeleton';

interface GroupGradesPreviewProps {
  groupId: number;
  userId?: number;
}

export default function GroupGradesPreview({ groupId, userId }: GroupGradesPreviewProps) {
  const navigate = useNavigate();
  const { data: grades = [], isPending } = useGetUserGroupGrades(userId, groupId);

  if (!isPending && grades.length === 0) return null;

  return (
    <div className={'border-border-primary bg-surface-primary flex w-full flex-col gap-2 rounded-2xl border p-4'}>
      <Label className={'text-text-tertiary font-medium'}>Oceny</Label>
      <div className={'flex items-center gap-3'}>
        <div className={'scroll-fade-e flex min-w-0 flex-1 items-center gap-2 overflow-hidden'}>
          {isPending ? (
            <>
              <Skeleton className={'h-11 w-32 shrink-0 rounded-lg'} />
              <Skeleton className={'h-11 w-32 shrink-0 rounded-lg'} />
              <Skeleton className={'h-11 w-32 shrink-0 rounded-lg'} />
            </>
          ) : (
            grades.map((grade) => (
              <GradeDetailsPopup key={grade.id} grade={grade}>
                <button
                  type={'button'}
                  className={
                    'border-border-primary bg-background hover:bg-accent/50 outline-focus-ring-primary flex shrink-0 items-center gap-2 rounded-lg border px-2.5 py-1.5 text-left outline-0 focus-visible:outline-3'
                  }
                >
                  <GradeValuePill grade={grade} />
                  <div className={'flex min-w-0 flex-col'}>
                    <span className={'text-foreground max-w-32 truncate text-sm font-medium'}>{grade.name}</span>
                    <span className={'text-muted-foreground text-xs'}>{format(new Date(grade.createdAt), 'd MMM yyyy')}</span>
                  </div>
                </button>
              </GradeDetailsPopup>
            ))
          )}
        </div>
        <Badge variant={'muted'} size={'sm'} className={'text-muted-foreground shrink-0 cursor-pointer'} onClick={() => navigate(`/groups/${groupId}/grades`)}>
          wszystkie
          <ArrowUpRight />
        </Badge>
      </div>
    </div>
  );
}
